module.exports = __webpack_public_path__ + "static/media/broken clouds 04d.a1cb48a6.png";